const areas = [
    {
        path: '/areas',
        name: 'Areas',
        component: () => import('@/views/areas'),
        children: [],
        meta: {
            requiresAuth: false,
        },
    },
]

export default areas